export const setStorage = (code: string, value: any, type: number = 1) => {
  const objType = Object.prototype.toString.call(value);
  const strType = objType.split(" ")[1].substr(0, objType.split(" ")[1].length - 1);
  const c = code;
  let res: any;

  if (strType === "Object" || strType === "Array") {
    res = JSON.stringify(value);
  } else {
    res = value;
  }
  if (type !== 1) {
    window.localStorage.setItem(c, res);
  } else {
    window.sessionStorage.setItem(c, res);
  }

  const localList = JSON.parse(window.localStorage.getItem("localList") || "{}");
  if (!localList[code]) {
    localList[code] = strType;
    window.localStorage.setItem("localList", JSON.stringify(localList));
  }
};

export const getStorage = (code: string, type: number = 1) => {
  const localList = JSON.parse(window.localStorage.getItem("localList") || "{}");
  const c = code;
  const vl: any = type !== 1 ? window.localStorage.getItem(c) : window.sessionStorage.getItem(c);

  switch (localList[code]) {
    case "Boolean":
      return vl === "true";
    case "Array":
    case "Object":
      return JSON.parse(vl);
    default:
      try {
        if (typeof JSON.parse(vl) == "object") {
          return JSON.parse(vl);
        }
      } catch (e) { }
      return vl;
  }
};

export const removeStorage = (code: string, type: number = 1) => {
  const c = code;

  if (type !== 1) {
    window.localStorage.removeItem(c);
  } else {
    window.sessionStorage.removeItem(c);
  }
};

export const cleanStorage = () => {
  const username = getStorage("username", 0);
  const password = getStorage("password", 0);
  window.sessionStorage.clear();
  window.localStorage.clear();
  setStorage("username", username, 0);
  setStorage("password", password, 0);
  window.location.href = "/";
};

export const registerSetSessionStroageEvent = (sessionName: string) => {
  const event: any = new Event(`sessionEvent_${sessionName}`);
  return event;
};

export const getSessionStroageEventName = (sessionName: string) => `sessionEvent_${sessionName}`;

export const checkWindowStorage = (valueName: any, storageName: string, type: number = 1) => {
  if (Object.keys(window[valueName]).length === 0) {
    window[valueName] = getStorage(storageName, type) ?? {};
    return false;
  }
  return true;
};